const changeExecutorDeniedCauseInvite = {
    title: 'Ошибка сохранения',
    description:
        'Нельзя редактировать <b>данные исполнителя</b>, если исполнитель <b>не принял</b> запрос на подключение',
    buttonText: 'Понятно',
    mode: 'denied',
} as const;

export default changeExecutorDeniedCauseInvite;
